query AvailableDeliveryAddresses {
  availableDeliveryAddresses {
    nodes {
      id
      addressAlias
      addressLine1
      addressLine2
      cityName
      countryId
      stateRegionId
      postalCode
      emailAddress
      telephoneNumber
    }
  }
}
